import { select } from 'redux-saga/effects';
import asyncDebounce from './asyncDebounce';
import { selectMapGeom } from './map/selection';
import { generateGeocodedMarker, removeGeocodedMarker } from './map/address-marker';
import { selectCacheVersion } from '../reducers/cacheVersion';

export const geocodeSuggestSearch = asyncDebounce(({ level, text, cacheVersion }) => fetch(`/api/suggest/${level}?text=${text}&v=${cacheVersion}`)
  .then((resp) => resp.json()), 250);

export const handleAddressSelection = async ({ selection, table }) => {
  if (selection && selection.value) {
    if (selection.value.id && selection.value.name) {
      await selectMapGeom({ id: selection.value.id, table, zoomTo: true });
    } else if (selection.value.address && selection.value.magicKey) {
      const { address } = selection.value;
      const cacheVersion = await select(selectCacheVersion);
      const geoJSON = await fetch(`/api/geocode?address=${address}&v=${cacheVersion}`)
        .then((res) => res.json());
      if (geoJSON) {
        generateGeocodedMarker(geoJSON);
        const [x, y] = geoJSON.geometry.coordinates;
        const { feature } = await fetch(`/api/feature/${table}?x=${x}&y=${y}&v=${cacheVersion}`)
          .then((res) => res.json());
        selectMapGeom({ id: feature.properties.id, table });
      } else {
        // notify user selection is not supported
      }
    }
  } else {
    removeGeocodedMarker();
  }
};

/*
  WORKING EXAMPLE REQUEST: {
    address: 49 FAYETTE STREET, CAMBRIDGE, MA, 02139,
    magicKey: GST7YMc0AM9UOsKtJSVZOc5GQSFQOc5GQS1F
  }
*/
